export const TypesOperacaoContainer = {
    SET_CONTAINER: "operacaoContainer/SET_CONTAINER",
    RESET_OPERACAO_CONTAINER: "operacaoContainer/RESET_OPERACAO_CONTAINER",
    SET_AJUDANTES: "operacaoContainer/SET_AJUDANTES",
    SET_FISCAIS: "operacaoContainer/SET_FISCAIS",
    SET_EVENTOS_OPERACAO_CONTAINER: "operacaoContainer/SET_EVENTOS_OPERACAO_CONTAINER",
    SET_TIPOS_LACRES: "operacaoContainer/SET_TIPOS_LACRES",
    SET_FISCAL: "operacaoContainer/SET_FISCAL",
    SET_OPERACAO: "operacaoContainer/SET_OPERACAO",
    SET_OBSERVACAO: "operacaoContainer/SET_OBSERVACAO",
    SET_DADOS_CONTAINER: "operacaoContainer/SET_DADOS_CONTAINER"
}

export const INITIAL = {
    container: '',
    dis: '',
    observacao: '',
    tiposLacre: [],
    eventosOperacaoContainer: [],
    fiscais: [],
    regime: '',
    dataUltimoEvento: '',
    ajudantes: [],
    lacresContainer: [],
    operacao: 
    {
        lacres: [],
        ajudantes: [],
        eventoOperacao: '',
        fiscal: '',
        data: '',
        tipoMovimentacao: '',
        tipoOperacao: '',
        observacao: ''
    }
}

export const OperacaoContainerActions =
{
    setContainer,
    resetContainer,
    setOperacao,
    setAjudantes,
    setEventosOperacaoContainer,
    setFiscais,
    setFiscal,
    setTiposLacres,
    setObservacao,
    setDadosContainer,
    setLacresOperacao,
    setAjudantesOperacao,
    setEventoOperacao,
    setTipoOperacao,
    setDataOperacao,
    setTipoMovimentacao
}

export default function operacaoContainerReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesOperacaoContainer.SET_CONTAINER:
            return {
                ...state,
                container: action.payload
            }
        case TypesOperacaoContainer.SET_EVENTOS_OPERACAO_CONTAINER:
            return {
                ...state,
                eventosOperacaoContainer: action.payload
            }
        case TypesOperacaoContainer.SET_TIPOS_LACRES:
            return {
                ...state,
                tiposLacre: action.payload
            }
        case TypesOperacaoContainer.SET_AJUDANTES:
            return {
                ...state,
                ajudantes: action.payload
            }
        case TypesOperacaoContainer.SET_OPERACAO:
            return {
                ...state,
                operacao: {...state.operacao, ...action.payload}
            }
        case TypesOperacaoContainer.SET_FISCAIS:
            return {
                ...state,
                fiscais: action.payload
            }
        case TypesOperacaoContainer.SET_OBSERVACAO:
            return {
                ...state,
                observacao: action.payload
            }
        case TypesOperacaoContainer.SET_DADOS_CONTAINER:
            return {
                ...state,
                fiscais: action.payload.Fiscais,
                observacao: action.payload.Observacao,
                tiposLacre: action.payload.TiposLacres,
                regime: action.payload.Regime,
                container: action.payload.Container,
                lacresContainer: action.payload.ListaLacres,
                dataUltimoEvento: action.payload.DataUltimoEvento,
                eventosOperacaoContainer: action.payload.EventosOperacaoContainer
            }
        case TypesOperacaoContainer.RESET_OPERACAO_CONTAINER:
            return INITIAL
        default:
            return state;
    }
}

function setContainer(container) {
    return {
        type: TypesOperacaoContainer.SET_CONTAINER,
        payload: container
    }
}

function setTiposLacres(lacres) {
    return {
        type: TypesOperacaoContainer.SET_TIPOS_LACRES,
        payload: lacres
    }
}

function setOperacao(operacao) {
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: operacao
    }
}

function setEventoOperacao(evento)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { eventoOperacao: evento }
    }
}

function setLacresOperacao(evento)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { lacres: evento }
    }
}

function setDataOperacao(data)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { data: data }
    }
}

function setFiscal(fiscal)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { fiscal: fiscal }
    }
}

function setTipoMovimentacao(tipoMovimentacao)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { tipoMovimentacao: tipoMovimentacao }
    }
}

function setTipoOperacao(tipoOperacao)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { tipoOperacao: tipoOperacao }
    }
}
function setObservacao(observacao)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { observacao: observacao }
    }
}

function setAjudantesOperacao(ajudantesOperacao)
{
    return {
        type: TypesOperacaoContainer.SET_OPERACAO,
        payload: { ajudantes: ajudantesOperacao }
    }
}

function setAjudantes(ajudantes) {
    return {
        type: TypesOperacaoContainer.SET_CONTAINER,
        payload: ajudantes
    }

}
function setEventosOperacaoContainer(eventos) {
    return {
        type: TypesOperacaoContainer.SET_EVENTOS_OPERACAO_CONTAINER,
        payload: eventos
    }

}
function setFiscais(fiscais) {
    return {
        type: TypesOperacaoContainer.SET_FISCAIS,
        payload: fiscais
    }
}

function setDadosContainer(dadosContainer) {
    return {
        type: TypesOperacaoContainer.SET_DADOS_CONTAINER,
        payload: dadosContainer
    }
}

function resetContainer() {
    return { type: TypesOperacaoContainer.RESET_OPERACAO_CONTAINER }
}